import styled from 'styled-components'

export const OtpRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
`

export const BtnRow = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: center;
`

export const WarningRow = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: center;
`

export const ResendRow = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: center;
`
export const StyledOtpImg = styled.img`
  width: 137px;
  height: 120px;
  display: flex;
  margin: auto;
`

export const ContainerTxt = styled.div`
  display: flex;
  justify-content: center;
`

export const SpanLink = styled.span`
  color: #00B4A5;
  cursor: pointer;
  font-weight: bold;
`

export const ContainerError = styled.div`
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
  position: relative;
  border: 1px solid transparent;
  border-radius: .25rem;
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
`